import React, { useState, useEffect, useRef } from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { Container } from "react-bootstrap";
import styleClasses from "./ItemsCategories.module.scss";
import Spinner from "../../components/Spinner/Spinner";
import * as CONSTANT from "../../constants";
import { useStoreLocation } from "../../context/StoreLocation";
import useGetMenuCategories from "../../react-query-hooks/useGetCategories";
import "./ItemCategoriesSlider.scss";
import "swiper/swiper.scss";
import "swiper/modules/navigation/navigation.scss";
import { Navigation, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";

const ItemsCategories: React.FC<RouteComponentProps> = ({ history }) => {
  const [isDeviceIos, setIsDeviceIos] = React.useState(false);
  const swiperRef = useRef(null);

  const { locationInfo } = useStoreLocation();
  const locationId = locationInfo.selectedStore?.id;
  const { data: menus = [] , isLoading} = useGetMenuCategories();
  const isItMobile = useCheckMobileScreen();

 
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/iPad|iPhone|iPod|Mac/.test(userAgent) && !window.MSStream) {
      setIsDeviceIos(true);
    } else {
      setIsDeviceIos(false);
    }
  }, []);

  useEffect(() => {
    if (menus.length > 0 && swiperRef.current) {
      swiperRef.current.swiper.slideTo(5);
    }
  }, [menus]); 

  const showDetails = (menu) => {
    history.push(`${CONSTANT.ROUTE_MENU}/${menu.name.replace(/\s/g, "%20")}`);
  };

  const getColorById = (id) => {
    const colorMap = {
      "2": "#0956A8",
      "3": "#198000",
      "4": "#C53E00",
      "5": "#198000",
      "7": "#0956A8",
      "8": "#0956A8",
      "9": "#198000",
      "11": "#0956A8",
      "18": "#198000",
      "23": "#C53E00",
      "21": "#C53E00",
    };
    return colorMap[id] || "#C53E00";
  };

  return isLoading ? (
    <Spinner lightBg={true}></Spinner>
  ) : (
    <div>
      <div className={`${styleClasses.menuCategoryWrapper}`}>
        {isItMobile ? (
          <Container fluid>
            <div className="row gx-3">
              {menus.slice(0, 6).map((menu, index) => {
                return (
                  <div key={menu.id} className="col-6">
                    <div className={styleClasses.cardWrapper}>
                      <h2
                        className={styleClasses.menuTitle}
                        style={{ background: getColorById(menu.id) }}
                      >
                        {menu.name}
                      </h2>
                      <div
                        className={styleClasses.menuItemCard}
                        onClick={() => showDetails(menu)}
                      >
                        <img
                          src={
                            isDeviceIos
                              ? `${CONSTANT.REACT_APP_CLOUD_FRONT}/images/Menu/${menu.name.replace(/'/g, "").toLowerCase()}.png?v=${menu?.image_version || Date.now()}`
                              : `${CONSTANT.REACT_APP_CLOUD_FRONT}/images/Menu/${menu.name.replace(/'/g, "").toLowerCase()}.png?v=${menu?.image_version || Date.now()}`
                          }
                          className="img-fluid"
                          alt={menu.name}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Container>
        ) : (
          <div className={`item-categories-swiper-slider-wrapper`}>
            <Swiper
              modules={[Navigation, Scrollbar]}
              ref={swiperRef}
              spaceBetween={30}
              autoplay={false}
              navigation={true}
              loop={true}
              centeredSlides={true}
              initialSlide={5} 
              pagination={{ clickable: false }}
              scrollbar={{ draggable: true }}
              breakpoints={{
                320: { slidesPerView: 1 },
                768: { slidesPerView: 2.5 },
                992: { slidesPerView: 2 },
                1200: { slidesPerView: 4 },
                1367: { slidesPerView: 4 },
              }}
              className={`${styleClasses.menuSliderWrapper} p-1 position-relative`}
            >
              <div className={styleClasses.whitishOverlayStart}></div>
              {menus.map((menu, index) => (
                <SwiperSlide key={menu.id}>
                  <div className={styleClasses.cardWrapper}>
                    <h3
                      className={styleClasses.menuTitle}
                      style={{ background: getColorById(menu.id) }}
                    >
                      {menu.name}
                    </h3>
                    <div
                      className={styleClasses.menuItemCard}
                      onClick={() => showDetails(menu)}
                    >
                      <img
                        src={
                          isDeviceIos
                            ? `${CONSTANT.REACT_APP_CLOUD_FRONT}/images/Menu/${menu.name.replace(/'/g, "").toLowerCase()}.png?v=${menu?.image_version || Date.now()}`
                            : `${CONSTANT.REACT_APP_CLOUD_FRONT}/images/Menu/${menu.name.replace(/'/g, "").toLowerCase()}.png?v=${menu?.image_version || Date.now()}`
                        }
                        className="img-fluid"
                        alt={menu.name}
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
              <div className={styleClasses.whitishOverlayEnd}></div>
            </Swiper>
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(ItemsCategories);
